import { render, staticRenderFns } from "./DeliveryGroupAddTemplateForm.vue?vue&type=template&id=431c39e0&scoped=true&"
import script from "./DeliveryGroupAddTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./DeliveryGroupAddTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryGroupAddTemplateForm.vue?vue&type=style&index=0&id=431c39e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431c39e0",
  null
  
)

export default component.exports